module.exports = __webpack_public_path__ + "img/visa.e6a05e38.png";